export default "__VITE_ASSET__J_v$hFub__"